import { apiFetch } from "./client";
import type { Vista } from "./preventivo";

// Link per l'amministratore (spec § 8; giro 2 dopo la revisione di sicurezza). Il token del link sta nel frammento
// della pagina (/p/#<token>) e si manda solo nell'intestazione X-Copia-Token, mai nell'indirizzo. Ogni file ha un token
// suo, di 15 minuti, che la risposta della copia dà bolletta per bolletta. Fetch semplice: nessun cookie del portale (la
// pagina è pubblica) e il token non finisce nel registro degli errori recenti del portale.

const COPIA = "/api/preventivo/copia";

/** La copia come la manda il server: la vista ridotta, il mittente e i token dei file (una bolletta senza file non
 *  c'è: quel mese resta senza link). */
export interface Copia extends Vista {
  file: Record<string, string>;
  preparato_da: string | null;
  preparato_il: string;
}

/** Risposta della copia che non è una copia: `scaduto` per i 4xx (scaduto, spento, manomesso, mai esistito),
 *  altrimenti un guasto da riprovare. */
export class ErroreCopia extends Error {
  scaduto: boolean;
  constructor(scaduto: boolean) {
    super(scaduto ? "link_scaduto" : "guasto");
    this.scaduto = scaduto;
  }
}

export const linkApi = {
  /** Il link coi soli condomìni spuntati (chiavi della vista dell'operatore). */
  crea: (pid: string, condomini: string[]) => apiFetch<{ token: string; scade_il: string }>(`/preventivo/${pid}/link`, {
    method: "POST", body: JSON.stringify({ condomini }),
  }),
  copia: async (token: string): Promise<Copia> => {
    const r = await fetch(COPIA, { headers: { "X-Copia-Token": token }, credentials: "omit", cache: "no-store" });
    if (!r.ok) throw new ErroreCopia(r.status >= 400 && r.status < 500 && r.status !== 429);
    return (await r.json()) as Copia;
  },
  fileUrl: (tokenFile: string) => `${COPIA}/file/${encodeURIComponent(tokenFile)}`,
  /** L'indirizzo da dare all'amministratore: il token nel frammento, che non arriva a nessun server. */
  indirizzo: (token: string) => `${window.location.origin}/p/#${token}`,
};
